import useOffersLoader from "../common/useOffersLoader";
import useDefaultLabelPrint from "./useDefaultLabelPrint";
import usePickupTimeFramesLoader from "./usePickupTimeFramesLoader";

const useSenderSideEffects = (): void => {
  usePickupTimeFramesLoader();
  useDefaultLabelPrint();
  useOffersLoader();
};
export default useSenderSideEffects;
